import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-14" data-testid="footer">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 flex flex-wrap items-center justify-between gap-8">
        <div className="flex items-center gap-3">
          <img src="https://lypinn.com/brand/lypinn-icon-1024.png" alt="LyPinn" className="w-8 h-8 rounded-md" />
          <div>
            <p className="font-display font-bold">LYPINN <span className="text-[#E5FF00]">PULSE</span></p>
            <p className="font-mono-tech text-[10px] tracking-[0.25em] text-zinc-600">BUILT WITH LOVE IN AHMEDABAD, IN</p>
          </div>
        </div>
        <div className="flex items-center gap-8 font-mono-tech text-[11px] tracking-[0.2em] text-zinc-500">
          <a href="https://lypinn.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-testid="footer-link-lypinn">
            LYPINN.COM
          </a>
          <a href="#contact" className="hover:text-white transition-colors" data-testid="footer-link-contact">
            CONTACT
          </a>
          <Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-link-terms">
            TERMS
          </Link>
          <span className="text-zinc-700">© 2026 LYPINN</span>
        </div>
      </div>
    </footer>
  );
}
